import script from "./ToggleSwitch.vue?vue&type=script&setup=true&lang=js"
export * from "./ToggleSwitch.vue?vue&type=script&setup=true&lang=js"

import "./ToggleSwitch.vue?vue&type=style&index=0&id=a1678342&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a1678342"]])

export default __exports__